// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a9e9b0b8","455":"a848fa9c","977":"6b528eb6"}[chunkId] + ".chunk.js";
};